export default __webpack_public_path__ + "static/media/plate_time.3f2f141a.jpg";